import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { BackIcon, EditIcon } from '../../Svg/Index.js'
import { SET_PROFILE_OPEN, SET_TYPE } from '../../Actions/Sidebar'
import { UPDATE_USER, DELETE_USER } from '../../Actions/User'
import { withRouter } from 'react-router-dom';

class EditProfile extends Component {
    constructor(props) {
        super()
        this.state = {
            bio: props.user.bio,
            pronouns: props.user.pronouns,
            response: false,
            dialogActive: false
        }
    }

    componentDidMount() {
        
    }

    handleCloseEdit = ()=> {
        this.props.actions.SET_TYPE('');
    }

    handleAvatarPreview = ()=> {
        let fileInput = this.refs.avatar;
        if (fileInput.files && fileInput.files[0]) {
            let reader = new FileReader();
            reader.onload = (image)=> {
                this.refs.avatarPreview.src = image.target.result;
            }
            reader.readAsDataURL(fileInput.files[0]);
        }
    }

    handleProfileUpdate = ()=> {
        const { user } = this.props;
        let bio = this.refs.bio.value;
        let pronouns = this.refs.pronouns.value;
        let display_name = this.refs.display_name.value;
        let city = this.refs.city.value;
        let avatarFile = this.refs.avatar.files[0];

        this.props.actions.UPDATE_USER({
            ...user,
            bio,
            pronouns,
            display_name,
            city,
            avatarFile
        }).then(res => {
            this.props.actions.SET_TYPE('');
        }).catch(res => {
            this.setState({ response: 'Er is iets misgegaan, de wijzigingen zijn niet opgeslagen' })
        })
    }

    handleAccountDelete = ()=> {
        this.props.actions.DELETE_USER().then(async () => {
            await localStorage.removeItem('@JO:keycode');
            await localStorage.removeItem('@JO:user');
            this.props.history.push('/')
        })
    }

    render() {
        const { user } = this.props
        const { response, dialogActive } = this.state

        return (
            <div className="c-sidebar-profile c-sidebar-profile--edit">
                <button className="c-btn c-btn--back" onClick={this.handleCloseEdit}>
                    <BackIcon />
                </button>

                <div className="c-sidebar-profile__inner c-sidebar-profile__inner--alt">
                    <div className="c-user">
                        <h2 className="c-sidebar__subtitle">Vul je profiel aan</h2>
                        <label className="c-user__media c-user__media--edit" htmlFor="avatar">
                            <img src={user.avatar.user_avatar} alt="" ref="avatarPreview"/>
                            <span className="c-user__media-edit">
                                <EditIcon />
                            </span>
                            <input className="c-user__media-file-input" type="file" accept="image/x-png,image/jpeg" id="avatar" name="avatar" ref="avatar" onChange={this.handleAvatarPreview} />
                        </label>

                        <span className="c-user_edit-title">Schermnaam</span>
                        <input type="text" className="c-user__name c-user__name--edit" ref="display_name" maxLength="20" defaultValue={user.display_name} />
                        
                        <span className="c-user_edit-title">Woonplaats</span>
                        <input type="text" className="c-user__city c-user__city--edit" ref="city" maxLength="25" defaultValue={user.city} />
                        
                        <span className="c-user_edit-title">Biografie</span>
                        <textarea className="c-user__bio c-user__bio--edit" ref="bio" maxLength="5000" defaultValue={user.bio} />
                        
                        <span className="c-user_edit-title">Pronouns</span>
                        <input type="text" className="c-user__city c-user__city--edit" ref="pronouns" maxLength="25" defaultValue={user.pronouns} />

                        {
                            response && (
                                <div className="o-response">
                                    <span>{response}</span>
                                </div>
                            )
                        }

                        {
                            dialogActive && (
                                <div className="c-dialog">
                                    <div className="c-dialog__inner">
                                        <h2 style={{color: "#000", fontSize: '21px'}}>Je staat op het punt om je account te verwijderen! Weet je het heel zeker?</h2>
                                        <button className="c-btn c-btn--primary" onClick={this.handleAccountDelete}>Ja, verwijder mijn account</button>
                                        <button className="c-btn c-btn--primary" style={{marginTop: '14px'}} onClick={ () => this.setState({dialogActive: false}) }>Nee, annuleren</button>
                                    </div>
                                </div>
                            )
                        }

                        <button className="c-btn c-btn--wide c-btn--compact" style={{marginTop: '30px', marginBottom: '15px'}} onClick={ () => this.handleProfileUpdate() }>Update profiel</button>

                        <button className="c-btn c-btn--primary c-btn--wide c-btn--compact c-remove-account-btn" onClick={ () => this.setState({dialogActive: true}) }>Account verwijderen</button>

                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.user,
        sidebar: state.sidebar,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({SET_PROFILE_OPEN, SET_TYPE, UPDATE_USER, DELETE_USER }, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditProfile))